<template>
  <div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="开始时间">
                <el-date-picker
                  v-model="searchForm.startTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结束时间">
                <el-date-picker
                  v-model="searchForm.endTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="search-button">
              <el-button type="primary" @click="handleSearch">点击查询</el-button>
              <el-button @click="handleReset">重置</el-button>
              <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">专项人力账单列表</div>
    <el-card class="box-card">
      <div class="table-container">
        <div style="display: flex; align-items: center; margin-bottom: 20px; font-size: 14px">
          <span style="font-weight: bold; margin-right: 8px">专项人力总计（人次）：</span>
          <span style="color: #333">{{ totalManpower }}</span>
        </div>
        <el-table
          :data="tableData"
          border
          stripe
          @selection-change="handleSelectionChange"
          ref="table"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="序号" width="80"></el-table-column>
          <el-table-column prop="region" label="地区"></el-table-column>
          <el-table-column prop="type" label="计费类型"></el-table-column>
          <el-table-column prop="item" label="计费项"></el-table-column>
          <el-table-column prop="unit" label="计费单位"></el-table-column>
          <el-table-column prop="amount" label="计费数量"></el-table-column>
          <el-table-column prop="startTime" label="开始时间"></el-table-column>
          <el-table-column prop="endTime" label="结束时间"></el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';

export default {
  name: 'SpecialManpower',
  data() {
    return {
      debouncedExport: null,
      exportLoading: false,
      searchForm: {
        startTime: '',
        endTime: '',
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      selectedRows: [],
      headers: {
        id: '序号',
        region: '地区',
        type: '计费类型',
        item: '计费项',
        unit: '计费单位',
        amount: '计费数量',
        startTime: '开始时间',
        endTime: '结束时间',
      },
    };
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
    totalManpower() {
      return this.tableData.reduce((sum, item) => sum + (item.amount || 0), 0);
    },
  },
  created() {
    this.fetchTableData();
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    fetchTableData() {
      this.loading = true;
      // 模拟API调用
      this.loading = false;
      this.tableData = [];
      this.total = 2;
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchTableData();
    },
    handleReset() {
      this.searchForm = {
        startTime: '',
        endTime: '',
      };
      this.currentPage = 1;
      this.fetchTableData();
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        // 导出全部数据
        this.loading = true;
        const allData = this.selectedRows.length > 0 ? this.selectedRows : this.tableData;
        const totalManpower = allData.reduce((sum, item) => sum + (item.amount || 0), 0);

        // 创建工作表数据
        const worksheetData = [];

        // 第一行放置专项人力总计信息
        worksheetData.push({ '专项人力总计（人次）': '专项人力总计（人次）：' + totalManpower });

        // 添加表头作为第二行
        const headerRow = {};
        Object.values(this.headers).forEach((label) => {
          headerRow[label] = label;
        });
        worksheetData.push(headerRow);

        // 添加表格数据
        allData.forEach((row) => {
          const rowData = {};
          Object.keys(this.headers).forEach((key) => {
            rowData[this.headers[key]] = row[key] || '-';
          });
          worksheetData.push(rowData);
        });

        const worksheet = XLSX.utils.json_to_sheet(worksheetData, { skipHeader: true });

        // 设置更合理的列宽
        const colWidths = [];
        colWidths.push({ wch: 30 }); // 为专项人力总计设置更宽的宽度

        // 为其他列设置宽度
        Object.values(this.headers).forEach((header) => {
          if (header.includes('时间')) {
            colWidths.push({ wch: 20 }); // 时间字段宽一些
          } else if (header.includes('区域') || header.includes('岗位')) {
            colWidths.push({ wch: 18 }); // 文本字段适中
          } else {
            colWidths.push({ wch: 15 }); // 其他字段默认宽度
          }
        });

        worksheet['!cols'] = colWidths;

        // 设置第一行的合并单元格
        worksheet['!merges'] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: Object.keys(this.headers).length - 1 } },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '专项人力账单列表');

        const timestamp = this.$moment().format('YYYYMMDDHHmmss');
        const filename = `专项人力账单列表_${timestamp}.xlsx`;

        XLSX.writeFile(workbook, filename);
        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchTableData();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
  },
};
</script>

<style scoped>
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.box-card {
  margin-bottom: 20px;
}
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}
.search-form {
  width: 100%;
}
.search-button {
  display: flex;
  justify-content: flex-end;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>